import { render } from "./My.vue?vue&type=template&id=3f087c1e&scoped=true&ts=true"
import script from "./My.vue?vue&type=script&lang=ts"
export * from "./My.vue?vue&type=script&lang=ts"

import "./My.vue?vue&type=style&index=0&id=3f087c1e&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f087c1e"]])

export default __exports__